// src/components/MapPlaceholder.js
import React from 'react';
import './map/Map.css';

const MapPlaceholder = () => {
  return (
    <div className="map-placeholder">
      <div className="map-placeholder-content">
        <div className="map-placeholder-spinner"></div>
        <p>Loading map...</p>
      </div>
    </div>
  );
};

export default MapPlaceholder;